'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('index-blog', {
  onLoad: function onLoad() {
    var container = this.container;
    var blog = (0, _jquery2.default)(container).find('[data-featured-blog]');
    var limit = (0, _jquery2.default)(blog).data('blog-articles');

    var settings = (0, _slick2.default)({
      appendDots: (0, _jquery2.default)(blog).closest('.slick-slider-wrapper').find('.slick-dots-wrapper'),
      dots: true,
      slidesToShow: limit,
      slidesToScroll: limit,
      responsive: [{
        breakpoint: Breakpoints['small'],
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    blog.slick(settings);

    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);
  },
  onUnload: function onUnload() {}
});